export const TITLE_POPUP_ACTIVATE_BOOK = "Vui lòng kích hoạt để xem bản đầy đủ";
export const TITLE_POPUP_TOOL_ENTER_TEXT = "Thêm mới đoạn văn bản";
export const TITLE_POPUP_REPORT_ERROR = "Báo lỗi";
export const TITLE_POPUP_QUESTION_SET = "Tạo bộ câu hỏi mới";
export const TEXT_HEADER_REPORT_ERROR = "Chọn vấn đề bạn gặp phải";
export const TEXT_USER_INFO_REPORT = "Thông tin người góp ý";
export const TITLE_POPUP_REPORT_SUCCESS = "Gửi phản hồi thành công!";
export const TEXT_POPUP_REPORT_SUCCESS_1 = "Cảm ơn đóng góp của bạn";
export const TEXT_POPUP_REPORT_SUCCESS_2 =
  "Hoc10 sẽ tiếp tục cải tiến để trở nên hoàn thiện hơn.";
//export const TEXT_TITLE_LIST_BOOK_USED = "Kho sách của tôi";
export const TEXT_TITLE_LIST_BOOK_USED = "Sách giáo khoa cánh diều";
export const TEXT_TITLE_LIST_BOOK_TEACHER = "Sách giáo viên";
export const TEXT_TITLE_LIST_BOOK_TEST3710 = "Sách thẩm định";
export const TEXT_TITLE_LIST_BOOK_DOCUMENT = "Tài liệu bổ trợ";
export const TEXT_TITLE_LIST_WORK_BOOK = "Sách bổ trợ";
export const TEXT_TITLE_BOOKS = "Sách giáo khoa cánh diều";
export const TEXT_TITLE_REFERENCE_BOOK_VALUE = "Sách tham khảo";
export const TEXT_ENTER_THE_CARD_NUMBER_USED = "Nhập số thẻ sử dụng";
export const TEXT_CONFIRM = "Xác nhận";
export const TEXT_ADD = "Thêm mới";
export const TEXT_SEND = "Gửi";
export const TEXT_SEND1 = "Tạo";
export const TEXT_DONE = "Thay đổi";
export const TEXT_DONE_2 = "Hoàn Thành";
export const TEXT_NEXT = "Tiếp Tục";
export const TEXT_EDIT = "Sửa";
export const TEXT_ACTIVATE_BOOK = "Kích Hoạt";
export const TEXT_TITLE_UPDATE_INFORMATION =
  "Hoàn thiện nốt các thông tin để truy cập kho sách Cánh diều";
export const TEXT_CHANGE_PW_SUCCESS = "Thay đổi mật khẩu thành công";
export const TEXT_FULL_NAME = "Họ tên";
export const TEXT_DOB = "Ngày sinh";
export const TEXT_PROVINCE = "Tỉnh/Thành phố";
export const TEXT_DISTRICT = "Quận/Huyện/Thị xã";
export const TEXT_WARD = "Xã Phường/Thị trấn";
export const TEXT_CLASS = "Cấp";
export const TEXT_SCHOOL = "Trường";
export const TEXT_TYPE_SCHOOL = "Loại Trường";
export const TEXT_NEW_SCHOOL_NAME = "Tên Trường mới";
export const TEXT_PASSWORD = "Mật khẩu hiện tại ";
export const TEXT_NEW_PASSWORD = "Mật khẩu mới";
export const TEXT_CONFIRM_NEW_PASSWORD = "Nhập lại mật khẩu mới";
export const TEXT_PHONE = "Số điện thoại";
export const TEXT_VERIFY_PHONE_ERROR = "Số điện thoại đã tồn tại tài khoản.";
export const TEXT_VERIFY_EMAIL_ERROR = "Email đã tồn tại tài khoản.";
export const TEXT_EMAIL_UPDATE_INFORMATION = "Địa chỉ Email";
export const TEXT_JOP_UPDATE_INFORMATION = "Nghề nghiệp";
export const TITLE_POPUP_SUCCESS =
  "Bạn đã hoàn thiện thông tin đăng nhập \n truy cập ngay kho sách và học liệu điện tử";
export const TITLE_POPUP_ACTIVE_BOOK_SUCCESS = "KÍCH HOẠT THÀNH CÔNG";
export const BUTTON_ACCESS_TO_THE_SOFT_BOOK_STORE =
  "Truy cập kho sách Cánh Diều";
export const BUTTON_ACCESS_LOGIN_3710 = "Mời bạn truy cập kho sách thẩm định";
export const BUTTON_PLEASE_RE_LOGIN = "Đăng nhập";
export const BUTTON_ACCESS_QUIZ = "Vào tập huấn";
export const BUTTON_READ_NOW = "Xem ngay";
export const BUTTON_ACCESS_TO_THE_SOFT_BOOK_STORE_AFTER_ACTIVVE_BOOK =
  "ĐI ĐẾN KHO SÁCH CỦA TÔI";
export const TITLE_BANNER_HOME_1 = "Bộ sách giáo khoa";
export const TITLE_BANNER_HOME_1_1 = "Đọc sách cánh diều";
export const TITLE_BANNER_HOME_2 = "cánh diều";
export const TITLE_BANNER_HOME_2_1 = "miễn phí";
// export const TITLE_BANNER_HOME_3 = "kích hoạt bộ sách";
export const TITLE_BANNER_HOME_3 = "truy cập bộ sách";
export const TITLE_BANNER_HOME_4 = "cánh diều ngay hôm nay";
export const TITLE_BANNER_HOME_5 = "Bài kiểm tra tập huấn";
export const TITLE_BANNER_HOME_6 = "đã sẵn sàng";
export const TITLE_BANNER_INTRODUCE_1 = "giới thiệu";
export const TITLE_BANNER_INTRODUCE_2 = "bộ sách cánh diều";
export const TITLE_BANNER_TUTORIAL_1 = "tài liệu hướng dẫn";
export const TITLE_BANNER_TUTORIAL_2 = "sử dụng sách";
export const DESCRIPTION_BANNER_TUTORIAL_2 =
  "Đọc tài liệu hướng dẫn để hiểu hơn về cách sử dụng bộ sách Cánh Diều";
export const TITLE_BANNER_EDUCATION_1 = "chương trình";
export const TITLE_BANNER_EDUCATION_2 = "các môn học";
export const DESCRIPTION_BANNER_EDUCATION_2 = "Thuộc chương trình GDPT 2018";

export const TITLE_SECTION_HOME_1 = "Các đơn vị tổ chức biên soạn, xuất bản";
export const TITLE_SECTION_HOME_2 = "Ý nghĩa tên gọi “Cánh Diều”";
export const TITLE_SECTION_HOME_3 = "Nguồn vốn biên soạn, xuất bản";
export const CONTENT_SECTION_HOME_1 =
  "Bộ sách giáo khoa Cánh Diều (gồm sách giấy và phiên bản điện tử) do NXB Đại học Sư phạm, NXB Đại học Sư phạm TP. Hồ Chí Minh, Công ty Đầu tư Xuất bản – Thiết bị Giáo dục Việt Nam (VEPIC) và Monkey - Tiếng Anh cho mọi trẻ em phối hợp tổ chức biên soạn, xuất bản theo Chương trình Giáo dục phổ thông 2018.";
export const CONTENT_SECTION_HOME_2 =
  "“Cánh Diều” gắn với tuổi học trò nhiều ước mơ bay bổng. Các bài học trong sách gắn với thực tiễn cuộc sống như cánh diều gắn với mặt đất bằng dây diều, “Mang cuộc sống vào bài học – Đưa bài học vào cuộc sống”. Bộ sách tạo cơ hội cho học sinh bay cao trên bầu trời tri thức bao la như diều gặp gió.";
export const CONTENT_SECTION_HOME_3 =
  "Cánh Diều là bộ sách giáo khoa xã hội hóa duy nhất có đầy đủ sách của tất cả các môn học, hoạt động giáo dục và được tổ chức biên soạn, xuất bản bằng nguồn vốn xã hội hóa, hoàn toàn không sử dụng ngân sách nhà nước; chất lượng sách đi đôi với giá thành, phù hợp với đại đa số gia đình Việt Nam.";
export const CONTENT_SECTION_HOME_4 =
  "Tác giả bộ sách Cánh Diều là những nhà giáo, nhà khoa học tâm huyết và giàu kinh nghiệm, trong đó có tác giả là Tổng Chủ biên Chương trình Giáo dục phổ thông 2018 và nhiều tác giả là thành viên Ban Phát triển Chương trình tổng thể, Ban Phát triển các chương trình môn học thành lập theo Quyết định của Bộ trưởng Bộ GDĐT.";
export const CONTENT_SECTION_HOME_5 =
  "Kèm theo sách giấy có một số học liệu điện tử, phiên bản điện tử sách giáo khoa và các thiết bị dạy học giúp thầy cô giảm bớt lao động sư phạm và hỗ trợ học sinh, phụ huynh trong quá trình sử dụng sách.";
export const CONTENT_SECTION_HOME_6 =
  "Đây là năm học đầu tiên thực hiện Chương trình Giáo dục phổ thông 2018. Bộ sách lớp 1 Cánh Diều đã được các cơ sở giáo dục trong cả nước lựa chọn với tỉ lệ cao và được triển khai trong thực tế đạt hiệu quả tích cực.";
export const CONTENT_SECTION_HOME_7 =
  "Bộ sách Cánh Diều được xuất bản đủ các môn học, hoạt động giáo dục đáp ứng lộ trình thực hiện Chương trình Giáo dục phổ thông 2018, gồm: Tái bản 10 quyển lớp 1, xuất bản 11 quyển lớp 2 và 14 quyển lớp 6.";
export const TITLE_SECTION_HOME_4 = "Tác giả";
export const TITLE_SECTION_HOME_5 = "Học liệu điện tử";
export const TITLE_SECTION_HOME_6 = "Năm học 2020-2021";
export const TITLE_SECTION_HOME_7 = "Năm học 2021-2022";
export const TITLE_SECTION_BANNER_1 = "đăng ký ngay";
export const TITLE_SECTION_BANNER_4 = "để kích hoạt sách";
export const TITLE_SECTION_BANNER_2 =
  "Có đầy đủ sách của tất cả các môn học, hoạt động giáo dục";
export const TITLE_SECTION_BANNER_3 = "Đăng ký ngay để kích hoạt sách";
export const TITLE_SIGN_IN = "Đăng nhập";
export const TITLE_SIGN_IN_FOR_BOOK_TOOL = (
  <div>
    <p>Xin vui lòng đăng nhập để tiếp tục sử dụng</p>
    <p>thanh công cụ trên sách điện tử.</p>
  </div>
);
export const TITLE_SIGN_OUT = "Đăng ký";
export const LINK_ACTIVATE_BOOK = "Kích hoạt sách";
export const BUTTON_VIEW_ALL = "Xem tất cả";
export const TITLE_NOT_BOOK = "Bạn chưa có sách";
export const TITLE_BOOK_USED = "Kho sách của tôi";
export const TITLE_TEXT_BOOK = "Sách giáo khoa cánh diều";
export const TITLE_TEXT_BOOK_TEACHER = "Sách giáo viên";
export const TITLE_TEXT_BOOK_TEST_3710 = "Sách thẩm định";
export const TITLE_TEXT_BOOK_DOCUMENT = "Tài liệu bổ trợ";
export const TITLE_TEXT_WORK_BOOK = "Sách bổ trợ";
export const TITLE_POPUP_SUCCESS_LOGIN = "Bạn đã đăng nhập thành công";
export const TITLE_POPUP_NOT_SEEN_ANY_ACTIVITY =
  "Chúng tôi không thấy hoạt động nào từ bạn trên website Hoc10 trong vòng 60 phút qua. Vui lòng đăng nhập lại để tiếp tục sử dụng.";
export const TITLE_POPUP_SUCCESS_LOGIN_2 =
  "Hiện tại thông tin của anh chị chưa trùng khớp với thông tin từ Sở Giáo dục.HOC10 sẽ xử lý vấn đề này trong thời gian tới. Anh chị vẫn được làm bài kiểm tra tập huấn và chờ kết quả.";
export const TITLE_POPUP_SUCCESS_REGISTER = "Bạn đã tạo tài khoản thành công";
export const TITLE_POPUP_SUCCESS_REGISTER_1 = "Tài khoản của bạn đã được tạo";
export const TEXT_CONFIRM_PASS_WORD = "Mật khẩu xác nhận không chính xác";
export const TEXT_USER_NAME = "Username";
export const TEXT_HEADER_LOGIN = "Đăng nhập ngay để kích hoạt sách!";
export const TEXT_HEADER_REGISTER = "Đăng ký tài khoản ngay để kích hoạt sách!";
export const TEXT_NOTE_REGISTER = "";
export const TEXT_NOTE_1_REGISTER =
  "Bằng việc đăng ký, bạn đã đồng ý với các Điều khoản dịch và các chính sách riêng tư của chúng tôi. ";
export const TEXT_NOTE_LOGIN =
  "* Nếu đã sử dụng ứng dụng học tập Monkey, bạn có thể đăng nhập ngay bằng số điện thoại đã dùng trong ứng dụng.";
export const TITLE_BOOK_INTRODUCTION = "Giới thiệu sách";
export const TITLE_BOOK_TUTORIAL = "Tài liệu hướng dẫn sử dụng sách";
export const TITLE_BOOK_EDUCATION = "Chương trình các môn học";
export const TITLE_POPUP_NOTIFICATION = "Bạn chưa đăng nhập";
export const TITLE_POPUP_NOT_LOGIN =
  "Xin vui lòng đăng nhập đúng tài khoản để xem sách thẩm định.";
export const TITLE_POPUP_NOT_ACCESS_BOOK =
  "Bạn không có quyền truy cập đầu sách này. Xin vui lòng đăng nhập đúng tài khoản để xem sách thẩm định.";
export const TITLE_POPUP_SBT_NOTIFICATION =
  "Vui lòng đăng nhập và kích hoạt sách để xem phiên bản đầy đủ của Sách bài tập điện tử Cánh Diều.";
export const TITLE_POPUP_SGK_NOTIFICATION =
  "Vui lòng đăng nhập để xem phiên bản đầy đủ<br/> của Sách giáo khoa điện tử Cánh Diều.";
export const TITLE_POPUP_BUY_PAPER_BOOK =
  "Vui lòng dùng sách giấy để xem bản đầy đủ.";
export const TITLE_POPUP_BUY_PAPER_BOOK_5 =
  "VUI LÒNG XEM BẢN ĐẦY ĐỦ TRÊN SÁCH GIẤY";
export const TITLE_POPUP_BUY_PAPER_BOOK_1 =
  "Quý khách vui lòng liên hệ để được hướng dẫn mua sách Cánh Diều:";
export const TITLE_POPUP_BUY_PAPER_BOOK_2 = "- Miền Bắc: 0983 588258";
export const TITLE_POPUP_BUY_PAPER_BOOK_3 = "- Miền Trung: 0985 000306";
export const TITLE_POPUP_BUY_PAPER_BOOK_4 =
  "- Miền Nam: (028) 36369907 / 0918 957495";
export const TITLE_BUTTON_UPDATE = "Cập nhật thông tin";
export const TEXT_FINISH_UPDATE_INFO_1 =
  "CHÚC MỪNG BẠN ĐÃ HOÀN THIỆN THÔNG TIN ĐĂNG NHẬP !";
export const TEXT_FINISH_UPDATE_INFO_2 = "TRUY CẬP NGAY BỘ SÁCH CÁNH DIỀU";
export const TEXT_FINISH_UPDATE_INFO_3 = "TRUY CẬP NGAY BÀI KIỂM TRA TẬP HUẤN";
export const TEXT_FINISH_SEND_1 = "Bạn có chắc chắn muốn gửi lại thông tin";
export const TEXT_FINISH_SEND_2 = "tài khoản cho giáo viên?";
export const TEXT_VALUE_BUTTON_FINISH_UPDATE_INFO = "TRUY CẬP BỘ SÁCH";
export const TEXT_VALUE_BUTTON_FINISH_UPDATE_INFO_2 =
  "THAM GIA KIỂM TRA TẬP HUẤN";
export const TITLE_INSTRUCTION_ACTIVATED_BOOK = "hướng dẫn kích hoạt sách";
export const LABEL_BUTTON_BANNER_HOME_1 = "Đăng nhập để kiểm tra";
export const LABEL_BUTTON_BANNER_HOME_2 = "Tham gia tập huấn";
export const TITLE_SEARCH_NOT_BOOK = "Không tìm thấy";
export const TITLE_CONTACT = "thông tin doanh nghiệp";
export const TITLE_CONTACT_CONTENT_1 = "Công ty cổ phần One Percent";
export const TEXT_CHANGE_PASSWORD = "Bạn đã thay đổi mật khẩu thành công!";
export const TEXT_VALUE_BUTTON_CHANGE_PASSWORD = "Đăng nhập";
export const TEXT_TITLE_POPUP_SUPPORT =
  "Hướng dẫn sử dụng sách Cánh Diều phiên bản điện tử ";
export const TEXT_TITLE_POPUP_TEACHING_INFORMATION =
  "CẬP NHẬT THÔNG TIN GIẢNG DẠY";
export const TITLE_FORM_DASHBOARD = {
  1: "Thêm phòng",
  2: "Thêm Trường",
  3: "Thêm giáo viên",
};
export const TEXT_SPACE = " ";
export const TITLE_BOOK_EDUCATION_TEACHER = "Tài liệu tập huấn";
export const TEXT_REWORK = "Làm lại";
export const TEXT_EMAIL_VERIFY_OTP =
  "Vui lòng kiểm tra hộp thư đến trên email. Chúng tôi đã gửi mã xác nhận đến email:";
export const TEXT_PHONE_VERIFY_OTP =
  "Vui lòng kiểm tra điện thoại. Chúng tôi đã gửi mã xác nhận đến số điện thoại:";
export const TITLE_TRAINING_TEST = "Bài kiểm tra tập huấn";
export const TITLE_TRAINING_TEST_2 = "Dành cho giáo viên tiểu học, THCS";
export const FOOTER_TRAINING_TEST = "cấu trúc đề bài";
export const FOOTER_TRAINING_TEST_2 = [
  "Đề kiểm tra tập huấn được đưa ra dưới dạng trắc nghiệm do NXB Đại học Sư phạm và NXB Đại học Sư phạm TPHCM biên soạn.",
  "Giáo viên làm bài kiểm tra online và biết ngay kết quả sau khi hoàn thành.",
  "Không giới hạn thời gian làm bài kiểm tra. Kết quả cao nhất sẽ được gửi về email giáo viên và Sở/Phòng GD&ĐT.",
];
export const FOOTER_TRAINING_TEST_3 = [
  "Giáo viên đăng nhập tài khoản đã được gửi về email và cập nhật đầy đủ thông tin chính xác để được cấp chứng nhận kết quả bồi dưỡng theo quy định của Sở GD&ĐT.",
  "Giáo viên cần hoàn thành các bài kiểm tra tập huấn các môn mà giáo viên giảng dạy.",
];

export const DATE_TRAINING = {
  start: "16/07/2021",
  end: "31/07/2021",
};

export const TEXT_POPUP_TRAINING_TEST = [
  "Vui lòng cập nhật đầy đủ thông tin tài khoản để ",
  "được nhận kết quả tập huấn sớm nhất",
];
